/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <span>
    <a-button type="link"
              :danger="props.danger===true?true:false"
              :class="props.bgColor?'userDefBtn':''"
              :shape="props.round?'round':''"
              :ghost="props.ghost"
              :disabled="disabled"
              :size="props.size"
              @click="clickEventFun"
              class="xmButton audio-btn-base"
              :loading="showLoadingFlag"
              v-show="btnAclFlag"
              :style="[ctlStyle,props.bgColor?'--btn-bg-color:'+props.bgColor:'',props.labelColor?'--btn-font-color:'+props.labelColor:'']"
    >
    <template #icon>
      <span :class="record.btnIcon||props.btnIcon" v-if="props.btnIcon"
                          :style="'color:'+props.iconColor"
                          style="padding-right: 4px"></span></template>
    <span v-if="props.hideLabel!==true">
        {{ btnLabel || props.label }}
      </span>
    <slot></slot>
  </a-button>
  <audio ref="audioPlayerRef"  @ended="audioEnded"   :src="audioFilePath"></audio>
  </span>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "audio-btn-base",
});
</script>

<script lang="ts" setup>
import {Button as AButton} from "ant-design-vue";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {useCtlShowState} from "@/main-page/ctls/hooks/useCtlShowState";
import {useAudioPlayHooks} from "@/main-page/components/hooks/useAudioPlayHooks";
import GoingUtils from "@/utils/goingUtils";

interface propTypes {
  disabled:boolean,
  btnLabel: string,
  elConfig: any,
  loadingFlag:boolean,
  props: any,
  events: any,
  aclKey: string,
  record:any,
  styles: any,
  model: any,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  elConfig: {},
  styles: {},
  aclKey: '',
  record:{},
  disabled:false,
  loadingFlag:false,
  btnLabel: '',
  events: [],
  props: {},
  model: {},
})
const {props, styles, model, events, elConfig, aclKey,btnLabel,record}: any = toRefs(propsPage);

const { showLoadingFlag} = useCtlShowState({sectionConfig: props});
const {ctlStyle} = useCtlStyle({styles, props, elConfig});

const emits = defineEmits(['clickBtn']);

const {btnAclFlag}=useBtnAclHooks({aclKey,props});
const audioPlayerRef=ref(null);
const {playAudio,audioFilePath,audioEnded,stopAudio}=useAudioPlayHooks({audioPlayerRef,record});

const clickEventFun = () => {
  if(unref(record).btnIcon==null||'remix-icon ri-kaishi'===unref(record).btnIcon){
    unref(record).btnIcon='remix-icon ri-suspend';
    playAudio();
  }else{
    unref(record).btnIcon='remix-icon ri-kaishi';
    stopAudio();
  }
  if (!GoingUtils.isDesFlag()&&unref(props).hideLabel!==true) {
    if(propsPage.loadingFlag===false){
      showLoadingFlag.value=false;
    }else{
      showLoadingFlag.value=true;
    }
  }
  emits('clickBtn', {btnId: unref(props).value || unref(props).key});
  setTimeout(()=>{
    showLoadingFlag.value=false;
  },500)
}

</script>

<style type="text/css" lang="less">
.ant-modal {
  .ant-modal-footer {
    .panelBtns {
      .xmButton {
        .ant-btn {
          line-height: 1;
        }
      }
    }
  }
}
.ant-btn.userDefBtn.xmButton.audio-btn-base{
  color: var(--btn-font-color,#333);
  border-color: var(--btn-bg-color,#f0f0f0);
  background: var(--btn-bg-color,#f0f0f0);
}

</style>
